import { Col, Label, Row } from "reactstrap";

//App
import { XCloseButton } from "../../Buttons";
import useFormHeaderStyles from "./styles";
import { FormHeaderProps } from "../../../../types";
import EditButton from "../../Buttons/EditButton";
import { Chip } from "../../VFX-UI";

const FormHeader = (props: FormHeaderProps) => {
    const { title, subTitle, chipLabel, onClose, editActionHandler, formClassName } = props;
    const formHeaderStyles = useFormHeaderStyles();
    const className = formClassName ?? "pb-2 border-bottom";

    return (
        <div style={formHeaderStyles.container}>
            <div className={className}>
                <Row>
                    <Col xs={9} style={formHeaderStyles.titleContainer} >
                        <div>
                            {title && (<Label style={formHeaderStyles.title} className="me-3">{title}</Label>)}

                        </div>
                        {chipLabel && <Chip style={formHeaderStyles.chip} label={chipLabel} />}
                    </Col>
                    <Col xs={3}>
                        <div style={formHeaderStyles.buttonContainer}>
                            {editActionHandler && (
                                <EditButton editActionHandler={editActionHandler} />
                            )}
                            <XCloseButton closeActionHandler={onClose} />
                        </div>
                    </Col>
                </Row>
            </div>
            <Row>
                {subTitle && (<Label style={formHeaderStyles.subTitle} className="mt-1 me-3">{subTitle}</Label>)}
            </Row>
        </div>
    );
};

export default FormHeader;
